<template>
  <div class="min-h-screen flex flex-col">
    <the-header />
    <main class="flex-1">
      <router-view v-slot="slotProps">
        <component :is="slotProps.Component"></component>
      </router-view>
    </main>
    <the-footer />
  </div>
</template>
